import { getRangeValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';
import { getRangeText } from '../utils/getRangeText';

export const landArea: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getRangeValue('site')(jsonQuery);
    const rangeText = getRangeText(value);
    if (!rangeText) {
      return null;
    }

    return [
      {
        group: 'landArea',
        text: `Площадь комнаты ${rangeText} сот.`,
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setLandArea',
      arguments: [null, null],
    });
  },
};
